import {
	Table, Popconfirm, Pagination
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import "antd/lib/spin/style/index.css"
import CustomButton from '../../../components/CustomButton'
import {
	reOrgTypeActions
}from './store/actions'
import Notifications from '../../../helpers/Notifications'
import CustomInput from '../../../components/CustomInput'
import LocalLoading from '../../../components/Loading/Local'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import ChangeReOrgType from './change'
import moment from 'moment'
import ModalAudit from '../ModalAudit'

const ReOrgTypes = ({ isModify }) => {
	const [search, setSearch] = useState(null)
	const [page, setPage] = useState(1)
	const [record, setRecord] = useState(null)
	const [visible, setVisible] = useState(false)
	const [auditVisible, setAuditVisible] = useState(false)
	const [audit, setAudit] = useState(null)

	const { paged, pagedAudit, isSending, changed } = useSelector(state => state.reOrgTypeReducer)

	const pageSize = 10
	const [searchValue] = useDebounce(search, 500)
	const dispatch = useDispatch()

	const columns = [
		{
			dataIndex : 'code',
			inputType : 'text',
			key       : 'code',
			title     : 'Код'

		},
		{
			dataIndex : 'name',
			inputType : 'text',
			key       : 'name',
			title     : 'Наименование'
		},
		{
			title     : "Дата создания",
			dataIndex : 'createDate',
			key       : 'createDate',
			render    : (date) => moment(date).format("DD.MM.YYYY")
		}
	]

	const columnsAudit = [
		{
			dataIndex : "action",
			key       : "action",
			title     : "Действие"
		},
		{
			dataIndex : 'code',
			inputType : 'text',
			key       : 'code',
			title     : 'Код'

		},
		{
			dataIndex : 'name',
			inputType : 'text',
			key       : 'name',
			title     : 'Наименование'
		},
		{
			key       : "actionDateTime",
			title     : "Дата изменения",
			dataIndex : "actionDateTime"
		},
		{
			title     : "IP-адрес",
			key       : "ip",
			dataIndex : "ip"
		}
	]

	const getPaged = (values) => {
		dispatch(reOrgTypeActions.getPaged(values))
	}
	const getPagedAll = (values) => {
		dispatch(reOrgTypeActions.getPagedAll(values))
	}
	const getPagedAudit = (params) => {
		dispatch(reOrgTypeActions.getPagedAudit(params))
	}
	const remove = (values) => {
		dispatch(reOrgTypeActions.remove(values))
	}
	const restore = (values) => {
		dispatch(reOrgTypeActions.restore(values))
	}

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	useEffect(() => {
		onPaginationAuditChange(1)
	}, [audit])

	useEffect(() => {
		return () => {
			dispatch(reOrgTypeActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	const onPaginationChange = (page) => {
		setPage(page)
		const params = {
			name     : searchValue,
			page     : page,
			pageSize : pageSize
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	function onPaginationAuditChange(value){
		if (audit){
			getPagedAudit({
				id   : audit,
				page : value,
				pageSize
			})
		}
	}

	isModify
		? columns.push({
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img
						src={ UpdateIcon }
						title="Редактировать"
						onClick={ () => {
							setVisible(true)
							setRecord(record)
						} }
					/>
					<Popconfirm
						cancelText="Нет"
						okText="Да"
						placement="left"
						title={ !record.isDeleted ? 'Вы уверены, что хотите удалить данную запись?' : 'Вы уверены, что хотите восстановить данную запись?' }
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						} }
					>
						<img
							src={ !record.isDeleted ? DeleteIcon : RestoreIcon }
							title={ !record.isDeleted ? "Удалить" : "Восстановить" }
						/>
					</Popconfirm>
					<img
						className="audit-icon-svg"
						src={ AuditIcon }
						title="История изменений"
						onClick={ () => {
							setAuditVisible(true)
							setAudit(record.id)
						} }
					/>
				</div>
			)
		})
		: null

	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={ 64 }
					placeholder="Введите название"
					onChange={ (e) => setSearch(e.target.value) }
				/>
				{ isModify
					? (
						<CustomButton
							className="add-nsi"
							type="green"
							onClick={ () => {
								setRecord(null)
								setVisible(true)
							} }
						>
							<div>
								<img src={ AddIcon } />
								<span>
                                    Добавить
								</span>
							</div>
						</CustomButton>
					)
					: null }
			</div>
			<Table
				columns={ columns }
				dataSource={ paged?.items }
				loading={ { indicator : <LocalLoading />,
					spinning  : isSending } }
				pagination={ false }
				scroll={ { x: 1200 } }
			/>
			{ paged?.count > pageSize
				? (
					<Pagination
						showQuickJumper
						current={ page }
						pageSize={ pageSize }
						showSizeChanger={ false }
						size="small"
						total={ paged?.count }
						onChange={ onPaginationChange }
					/>)
				: null }
			{ isModify &&
			<>
				<ChangeReOrgType
					record={ record }
					setRecord={ setRecord }
					setVisible={ setVisible }
					visible={ visible }
				/>
				<ModalAudit
					columns={ columnsAudit }
					count={ pagedAudit.count }
					data={ pagedAudit.items }
					setIdRecordAudit={ setAudit }
					setPage={ onPaginationAuditChange }
					setVisible={ setAuditVisible }
					visible={ auditVisible }
				/>
			</> }
		</>
	)
}

export default ReOrgTypes